import { schema, types } from 'papr'

export const staticPageSchema = schema(
	{
		publication: types.objectId(),
		title: types.string({ required: true }),
		endpoint: types.string({ required: true }),
		content: types.string({ required: true }),
		contentMarkdown: types.string({ required: true }),
		oldEndpoint: types.string(),
		isActive: types.boolean(),
		isHidden: types.boolean(),
		priority: types.number(),
		ogImage: types.string(),
		description: types.string(),
	},
	{
		timestamps: true,
		defaults: {
			isActive: true,
			isHidden: false,
			priority: 0,
		},
	},
)

export type StaticPageDocument = (typeof staticPageSchema)[0]
export type StaticPageSchemaOptions = (typeof staticPageSchema)[1]
